import React, { useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import UserContext from 'contexts/UserContext'
import { useNavigate } from 'react-router-dom'
import ModalTestStatusUser from 'components/modalTestStatusUser'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import { LISTBANCAIRE } from 'components/listCartebancairepays'
import InputSelectComponent from 'components/inputSelectComponent'

interface Props {
  banqueName: any
  setBanqueName: (value: string) => void
  iban: any
  setIban: (value: string) => void
  setNumStep: (value: number) => void
  setSelectedBnfList: (value: any) => void
  selectedBnfList: any
  cinBnf: any
  setCinBnf: (value: any) => void
  bankcode: any
  setBankcode: (value: any) => void
  swiftBic: any
  setSwiftBic: (value: any) => void
  functionTracks: any
}

type RibLength = number | {
  min: number
  max: number
}

type typeListebank ={
  index: number;
   code: string; 
   name: string;
    swift: string;
}


const ListeCarteBancairePage: React.FC<Props> = ({
  banqueName,
  setBanqueName,
  iban,
  setIban,
  setNumStep,
  setSelectedBnfList,
  selectedBnfList,
  cinBnf,
  setCinBnf,
  bankcode,
  setBankcode,
  swiftBic,
  setSwiftBic,
  functionTracks,
}) => {
  const { user } = useContext(UserContext)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)

  const navigate = useNavigate()

  //test status user
  const statusComplete = user?.user?.status === 'confirmed' && user?.user?.isDocumentSent
  const statusPending = user?.user?.status === 'pending' && user?.user?.isDocumentSent
  const statusNotFound = user?.user?.status === 'pending' && !user?.user?.isDocumentSent

  // const [confirmerNumeroCompte, setConfirmerNumeroCompte] = useState(TransferData?.numBankBeneficiary || '')
  const [confirmerNumeroCompte, setConfirmerNumeroCompte] = useState('')

  const [errorRIB, setErrorRIB] = useState<boolean>()
  const [isValid, setIsValid] = useState<boolean>(true)
  const [isValidCin, setIsValidCin] = useState(true)
  const [lengthCIN, setLengthCIN] = useState<number>()
  const [lengthRIB, setLengthRIB] = useState<RibLength>()
  const [codeIBAN, setCodeIBAN] = useState<string>('')
  const [listePefixCodeIBAN, setListePefixCodeIBAN]=useState<string[]>([])
  const [errorConfirmedRIB,setErrorConfirmedRIB]= useState<boolean>()
  const [openIsModalStatus, setOpenIsModalStatus] = useState(false)

  const [errorMessageCIN, setErrorMessageCIN] = useState('')
  const [errorMessageRIB, setErrorMessageRIB] = useState('')
  const [isBankListOpen, setIsBankListOpen] = useState(false)
  const [bankName, setBankName]= useState(TransferData?.banqueName ? TransferData.banqueName : '')

const [listCarteBancaire, setListCarteBancaire]= useState<typeListebank[]>()
const  liste=TransferData?.codeIso==='TUR' || TransferData?.codeIso==='PHL'
? LISTBANCAIRE[TransferData?.codeIso].banks?.map((item)=>({value:item.name, code:item.code, swift:item.swift })) : ''


  const handleSelectedBank=(item:any)=>{
  setBankName(item.value)
  setTransferData((prev:any) => ({
  ...prev, banqueName: item.value, bankcode:item.code, swiftBic:item.swift}))
  setSwiftBic(item.swift)
  setBankcode(item.code)
}
     useEffect(()=>{
        const codeISO= TransferData?.codeIso
        if(!codeISO) return
          const data= LISTBANCAIRE[codeISO]
         
          setListCarteBancaire(data.banks)
          setLengthRIB(data.LengthRIB)
          setLengthCIN(data.LengthCIN)
          setCodeIBAN(data.CodeIBAN?? '')
          const prefix= data.banks?.map((item)=>item.code)
          setListePefixCodeIBAN(prefix ?? [])
                 
     },[TransferData?.codeIso])


     useEffect(()=>{
      if(TransferData?.cinBeneficiary && TransferData.numBankBeneficiary)
      {
        setIsValidCin(true)
        setIsValid(true)
      }
     
     },[])

  const openModalStatus = () => {
    setOpenIsModalStatus(true)
  }
  const closeModalStatus = () => {
    setOpenIsModalStatus(false)
  }
  const handleChangeCIN = (event: any) => {
    let regex
    let isValidInput=false
    let errorMessage=''
    const value = event.target.value

      if(lengthCIN){
        if(TransferData?.codeIso ==='MAR'){
           regex= /^[A-Z 0-9]{5,10}$/
           isValidInput = regex.test(value)
           errorMessage='Format CIN Maroc invalide '
        }else{
          // if(/^\d*$/.test(value)) return
          if (!/^\d*$/.test(value)) return
           regex= new RegExp(`^\\d{${lengthCIN}}$`)
           isValidInput = regex.test(value)
           errorMessage=`Le numéro de la carte d’identité nationale doit contenir exactement ${lengthCIN} chiffres.`
        }
        
        setIsValidCin(isValidInput)
        setIsValid(isValidInput)
        setCinBnf(value)
        if (!isValidInput)
        {setErrorMessageCIN(errorMessage)

        }else{

          setErrorMessageCIN('')
        }
      }
      
      setTransferData((prev:any) => ({
  ...prev, cinBeneficiary: event.target.value }))
  }
  const test = (iban: any) => {

      const matchedPrefix = listePefixCodeIBAN.find(prefix => iban.startsWith(prefix))

      const matchingBank = listCarteBancaire?.find((bank) => bank.code === matchedPrefix)

   if (matchingBank) {
      setBanqueName(matchingBank.name)
      setBankcode(matchingBank.code)
      setSwiftBic(matchingBank.swift)
     
     setTransferData((prev: any) => {
      const updated = {
        ...prev,
        banqueName: matchingBank.name,
        numBankBeneficiary: iban,
        bankcode: matchingBank.code,
        swiftBic: matchingBank.swift,
      }

  return updated
})
      setErrorRIB(false)
      setErrorMessageRIB(' ')


    } else {
      setErrorRIB(true)
      setErrorMessageRIB("Le RIB n’est pas correct")
      setBanqueName('')
      setBankcode('')
      setSwiftBic('')
      setTransferData((prev:any) => ({
  ...prev, banqueName: '' }))
    }
  }
//   const handleChangeIBAN = (event: any) => {
//     // const ibanWithoutPrefix = event.target.value.replace(/^TND59\s*/, '')
//     // const startsWith59 = ibanWithoutPrefix.startsWith('59')
//     const newValue = event.target.value

//     // Allow only numbers
//     if (/^\d*$/.test(newValue)) {
//       if(lengthRIB){
//         const regex= new RegExp(`^\\d{${lengthRIB}}$`)
//         const isValidInput = regex.test(newValue)
//       // const isValidInput = /^\d{20}$/.test(newValue)
//       // setErrorRIB(isValidInput)
//       setIban(newValue)
//       if(TransferData?.codeIso!=='TUR' && TransferData?.codeIso!=='PHL'){ 
//         test(newValue)
//       }
//       // setIsValid(isValidInput)

//       setTransferData((prev:any) => ({
//   ...prev, numBankBeneficiary: newValue }))
    
//     if (!isValidInput)
//     {
//       setErrorMessageRIB(`${TransferData?.valuePays==='TRY' || TransferData?.valuePays==="PHP" ? `L'IBAN` :'Le numéro de compte bancaire'}  doit contenir exactement ${lengthRIB} chiffres.`)
//       setErrorRIB(true)
//     }
//     else if( isValidInput && (TransferData?.codeIso==='TUR' || TransferData?.codeIso==='PHL')){
//       setErrorRIB(false)
//       setErrorMessageRIB('')
//     }
  
//     }
     
// }
//   }


const handleChangeIBAN = (event: any) => {
  const newValue = event.target.value

  // Autoriser uniquement les chiffres
  if (!/^\d*$/.test(newValue)) return

  if (!lengthRIB) return

  const isTURorPHL =
    TransferData?.codeIso === 'TUR' ||
    TransferData?.codeIso === 'PHL'

  let isValidLength = false

  // 1. Vérification longueur
  if (typeof lengthRIB === 'object') {
    // Exemple PHL : entre 10 et 16
    isValidLength =
      newValue.length >= lengthRIB.min &&
      newValue.length <= lengthRIB.max
  } else {
    // Autres pays : longueur exacte
    isValidLength =
      newValue.length === lengthRIB
  }

  setIban(newValue)

  setTransferData((prev: any) => ({
    ...prev,
    numBankBeneficiary: newValue,
  }))

  
  // TUR / PHL
  // On vérifie UNIQUEMENT la longueur.
  // Aucun test matchingBank.
  if (isTURorPHL) {
    if (!isValidLength) {
      if (typeof lengthRIB === 'object') {
        setErrorMessageRIB(
          `Le numéro de compte bancaire doit contenir entre ${lengthRIB.min} et ${lengthRIB.max} chiffres.`
        )
      } else {
        setErrorMessageRIB(
          `Le numéro de compte bancaire doit contenir exactement ${lengthRIB} chiffres.`
        )
      }

      setErrorRIB(true)
    } else {
      setErrorRIB(false)
      setErrorMessageRIB('')
    }

    return
  }

  // AUTRES PAYS
  
  // Si la longueur n'est pas correcte,
  // inutile de chercher la banque.
  if (!isValidLength) {
    if (typeof lengthRIB === 'object') {
      setErrorMessageRIB(
        `Le numéro de compte bancaire doit contenir entre ${lengthRIB.min} et ${lengthRIB.max} chiffres.`
      )
    } else {
      setErrorMessageRIB(
        `${
          TransferData?.valuePays === 'TRY'
            ? "L'IBAN"
            : 'Le numéro de compte bancaire'
        } doit contenir exactement ${lengthRIB} chiffres.`
      )
    }

    setErrorRIB(true)
    return
  }

  // Matching banque uniquement pour les autres
  test(newValue)
}



  const handleInputChangeConfirme = (event: any) => {
    const newValue = event.target.value
    if (/^\d*$/.test(newValue)) {
      const isValidInput = newValue === iban
  
      setConfirmerNumeroCompte(newValue)
      // setTransferData({ ...TransferData, confirmerNumeroCompte: newValue })
      setIsValid(isValidInput)
      // setErrorConfirmedRIB(isValidInput)
    }
  }
  useEffect(() => {
    if (TransferData?.numBankBeneficiary !== iban) setTransferData((prev:any) => ({
  ...prev, numBankBeneficiary: iban }))
      if(confirmerNumeroCompte !== iban){setErrorConfirmedRIB(true)}
    else{setErrorConfirmedRIB(false)}
  }, [TransferData?.numBankBeneficiary, confirmerNumeroCompte])

  useEffect(() => {
    if (TransferData) {
      setIban(TransferData?.numBankBeneficiary || '')
      if(TransferData.valuePays==='TND')
      {setCinBnf('00000000')
        setIsValidCin(true)
      }else
      {setCinBnf(TransferData?.cinBeneficiary || '')}
      // setConfirmerNumeroCompte(TransferData?.confirmerNumeroCompte || '')
      setBanqueName(TransferData?.banqueName || '')
      setBankcode(TransferData?.bankcode || '')
      setSwiftBic(TransferData?.swiftBic || '')
    }
  }, [])
  

  return (
    <div className="grid grid-cols-1 mt-5 sm:justify-center xl:w-full  gap-5 sm:gap-0 sm:mt-0">
      <label className="h3">
        Nom du bénéficiaire <span className="text-red-500">*</span>
      </label>

      <div className="h-[75px] sm:mt-2">
        <div className=" px-3 w-full flex items-center   h-[56px] sm:h-[50px] border  font-bold text-[15px] rounded-[16px] border-[#AEB6FB] text-[#35258B]">
          {selectedBnfList}
        </div>
      </div>
{TransferData?.valuePays!=='TND'&&
<div className='flex flex-col gap-5'>
      <label className="h3">
        Numéro de CIN du bénéficiaire <span className="text-red-500">*</span>
      </label>
      <div className="h-[75px] sm:h-[95px] ">
        <input
          type="text"
          value={cinBnf}
          name="cinBnf"
          onChange={handleChangeCIN}
          placeholder="Numéro de CIN du bénéficiaire"
          autoComplete="no"
          className="pl-3 w-full sm:mt-2 outline-none  border-[#AEB6FB] placeholder:text-[#D1D1FF]  text-[#35258B] border focus:border-[#5754E5] h-[56px]  sm:h-[50px]  font-bold text-[15px] rounded-[16px] "
          // maxLength={8}
        />
        {!isValidCin && (
          <p className="text-red-500 text-[13px]">
            {errorMessageCIN}
            {/* La carte d&apos;identité nationale doit contenir exactement 8 chiffres. */}
          </p>
        )}
      </div>
      </div>
}
      {(TransferData?.codeIso==='TUR' || TransferData?.codeIso==='PHL' )&&
       <div className=' mb-6 w-full'>
        <InputSelectComponent
                  liste={liste}
                  isOpen={isBankListOpen}
                  setIsOpen={setIsBankListOpen}
                  value={bankName}
                  setValue={setBankName}
                  placeholder='Sélectionnez votre banque'
                  label='Sélectionnez votre banque'
                  handleClick={handleSelectedBank}
                  messageIsEmpty='Aucunne banque ajouté pour le moment'
                />
        </div>
      }
         

      <label className="h3">
        Numéro {(TransferData?.valuePays==='TRY' || TransferData?.codeIso==='PHL') ? `IBAN` : 'de compte bancaire'}  <span className="text-red-500">*</span>
      </label>
      {TransferData?.valuePays ==='TND'&& 
      <span className='text-[#422EAE] text-[14px] sm:text-[12px] sm:-mt-0 -mt-3'>(Seuls les comptes en dinars tunisiens (TND) sont acceptés)</span>}
      <div className="h-[75px] sm:h-[95px] w-full">
        <div className="rounded-xl  flex items-center  gap-2 w-full  p-2  sm:mt-2  font-bold text-[15px]  h-[56px] sm:h-[50px] border-[#AEB6FB]  text-[#35258B]  border focus:border-[#5754E5] ">
          <span className=" text-[#1D3A70]  ">
            {codeIBAN}
            {/* {TransferData?.codeIso === 'XOF' ? 'SN' :TransferData?.codeIso === 'MAR' ? 'MA' :'TN59'} */}
          </span>
          <input
            type="text"
            value={iban}
            name="iban"
            onChange={handleChangeIBAN}
            placeholder={(TransferData?.valuePays==='TRY' || TransferData?.codeIso==='PHL') ? `Numéro IBAN` : 'Numéro de compte bancaire'}  

            className=" placeholder:text-[#D1D1FF] w-full outline-none "
             maxLength={
              typeof lengthRIB === 'object'
                ? lengthRIB.max
                : lengthRIB
            }
          />
        </div>
        {/* {!errorRIB && */}
          <p className="text-red-500 text-[13px]"> {errorMessageRIB }</p>
        {/* } */}

        {/* {errorNumber && <p className="text-red-500 text-[13px]">Le numéro 59 est deja existe.</p>} */}
      </div>

      <label className="h3">
        Confirmez le numéro {(TransferData?.valuePays==='TRY' || TransferData?.codeIso==='PHL') ? `IBAN` : 'de compte bancaire'} <span className="text-red-500">*</span>
      </label>
      <div className="h-[75px] sm:h-[95px] w-full">
        {/* <div className="rounded-xl h-[56px]   sm:h-[50px] 2sm:w-[320px] w-full flex"> */}
       <div className="rounded-xl  flex items-center  gap-2 w-full  p-2  sm:mt-2  font-bold text-[15px]  h-[56px] sm:h-[50px] border-[#AEB6FB]  text-[#35258B]  border focus:border-[#5754E5] ">

          <span className=" text-[15px]  text-[#1D3A70] ">
            {codeIBAN}
            </span>
          <input
            type="text"
            value={confirmerNumeroCompte}
            name="confirmerNumeroCompte"
            onChange={handleInputChangeConfirme}
            // maxLength={lengthRIB}
             maxLength={
              typeof lengthRIB === 'object'
                ? lengthRIB.max
                : lengthRIB
            }
            placeholder={(TransferData?.valuePays==='TRY' || TransferData?.codeIso==='PHL') ? `Confirmez le numéro IBAN` : 'Confirmez le numéro de compte bancaire'}  
            className="placeholder:text-[#D1D1FF] outline-none w-full "
          />
        </div>
        {confirmerNumeroCompte !== iban && confirmerNumeroCompte !== '' &&
         <p className="text-red-500 text-[13px]">Les numéros {(TransferData?.valuePays==='TRY' || TransferData?.codeIso==='PHL') ? `IBAN` : 'de compte bancaire'} ne correspondent pas.</p>}
      </div>

      <div className="text-center mx-auto text-[14px] sm:text-[12px] text-[#6B7280] w-[550px] sm:w-[300px] sm:pb-10">
        * Assurez-vous de vérifier soigneusement le numéro de compte bancaire avant d&apos;effectuer le transfert. En
        cas d&apos;erreur, il pourrait être difficile voire impossible de vous rembourser par la suite. Nous vous
        recommandons de prendre cette précaution pour garantir une transaction sans encombre.
      </div>

      <div className="flex  gap-[16px] justify-center w-full h-[56px] sm:h-[45px] sm:px-4 sm:mt-8">
        <button
          className={classNames(
              'text-[18px] text-[#5754E5]  hover:border-[#4D36CC] hover:bg-[#F1F1FF] border border-[#5754E5] w-[180px] sm:w-full rounded-[16px]',
          )}
          onClick={() => {
            setNumStep(1)
          }}
        >
          Précédent
        </button>

        <button
          className={classNames(
            
              errorRIB || errorConfirmedRIB ||!isValidCin
              || iban==='' || cinBnf === '' || ((TransferData?.codeIso === 'TUR' || TransferData?.codeIso === 'PHL' )&& bankName === '')
            
              ? 'bg-[#D1D1FF] hover:cursor-not-allowed'
              : 'bg-[#5754E5]  hover:bg-[#4D36CC]',
              'text-[18px] text-[#FFF]  sm:w-full rounded-[16px] w-[375px]  ',
          )}
          onClick={() => {
            if (statusComplete) {
              setNumStep(3)
              functionTracks('3')
            } else if (statusPending) {
              openModalStatus()
            } else if (statusNotFound) {
              navigate('/personalinformation')
            }
          }}
          disabled={
            errorRIB || errorConfirmedRIB ||!isValidCin
              || iban==='' || cinBnf === '' || ((TransferData?.codeIso === 'TUR' || TransferData?.codeIso === 'PHL' ) && bankName === '')
         
          }
        >
          Suivant
        </button>
      </div>
      <ModalTestStatusUser
        isOpen={openIsModalStatus}
        closeModal={closeModalStatus}
        statusPending={statusPending}
        statusNotFound={statusNotFound}
      />
    </div>
  )
}

export default ListeCarteBancairePage
